import {VGLawCookie} from "vglawcookie";

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedHeader($(window));
		Vegas.clones();
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		// navigation
		new VGNav({
			expand: 'lg',
			toggle: '<i class="fal fa-chevron-down"></i>'
		});

		// animation
		AOS.init({
			once: true,
		});

		$('.btn-load-more-portfolios').vegasLoadMore({
			limit: 9,
			offset: 9,
			onLoad: function ($self, data) {
				let target = $self.attr('data-target');

				$(target).append(data.view);

				if (!data.view || data.photos_count <= 9) {
					$self.hide();
				}
			},
			onClick: function ($self) {
				$self.text('Загружаю...')
			}
		});

		$(document).on('click', '.callibri_quiz_last_slide .callibri_quiz_next_btn', function () {
			yaCounterReachGoal('quiz-send');
		});

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		VegasCarousel.init();
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default, .page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedHeader: function ($self) {
		let $header = $('header'),
			scroll = $self.scrollTop(),
			$body = $('body');

		if (scroll > 500) {
			$header.find('.vg-header-wrapper').addClass('fixed');
			$header.find('.vg-header-wrapper').removeClass('scrolled');
			$body.addClass('vg-header-scroll');
		} else if (scroll > 100) {
			$header.find('.vg-header-wrapper').addClass('scrolled');
		} else {
			$header.find('.vg-header-wrapper').removeClass('fixed');
			$header.find('.vg-header-wrapper').removeClass('scrolled');
			$body.removeClass('vg-header-scroll');
		}

		/**
		 * scroll elements
		 * **/
		let $sidebar = $body.find('.vg-catalog-sidebar');

		if ($body.hasClass('vg-header-scroll') && $sidebar.length) {
			$sidebar.addClass('sticky');
		} else {
			$sidebar.removeClass('sticky');
		}
	},

	clones: function () {
		if (window.innerWidth < 1199) {
			let $obj_categories_clone = $('.vg-catalog-sidebar--categories');
			if($obj_categories_clone.length) {
				$obj_categories_clone.clone().detach();
				$('.vg-categories-clone-area').append($obj_categories_clone)
			}
		}
	}
};
